import Axios from 'axios'
import AppConfig from "../appConfig"

/**
 * Checks if token can be obtained and then redirect to given path via Vue Router
 *
 * @param {string} path
 * @param {VueRouter} router
 */
function checkToken() {
  // if (process.env.NODE_ENV === 'development') {
  return Axios.get('/api/token',
    {
      auth: {
        username: AppConfig.tokenCredentials.user,
        password: AppConfig.tokenCredentials.pass
      }
    }
  ).then(result => {
    return result.data.token
  })
  // }
}

function getToken() {
  // if (process.env.NODE_ENV === 'development') {
  return Axios.get('/api/token',
    {
      auth: {
        username: AppConfig.tokenCredentials.user,
        password: AppConfig.tokenCredentials.pass
      }
    })
  // }
}

export default {checkToken, getToken}



// WEBPACK FOOTER //
// ./src/service/TokenService.js